export const browserStackLocalUrl = 'bs-local.com'
export const useBrowserStackLocal = process.env.USE_BROWSERSTACK_LOCAL === 'true'
